import {Component, Optional} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {AlertComponent} from '../alert/alert.component';
import {TranslateModule} from '@ngx-translate/core';
import {TableModule} from 'primeng/table';
import {AbstractSigaleComponent} from '../abstract-sigale.component';
import {ProprieteService} from './propriete.service';
import {AlertService} from '../alert/alert.service';

@Component({
	standalone: true,
	selector: 'propriete',
	templateUrl: './propriete.component.html',
	styleUrls: ['./propriete.component.scss'],
	imports: [
		CommonModule,
		FormsModule,
		AlertComponent,
		TranslateModule,
		TableModule
	]
})
export class ProprieteComponent extends AbstractSigaleComponent {
	appProperties: any;
	loadingIndicator: boolean;

	sort = [{
		prop: 'property',
		dir: 'desc'
	}];

	constructor(@Optional() private route: ActivatedRoute, private proprieteService: ProprieteService, private alertService: AlertService) {
		super();
		if (this.route?.snapshot?.data) {
			this.appProperties = this.route?.snapshot?.data['appProperties'];
		}
	}


	ngOnInit() {
		super.ngOnInit();
		if (this.appProperties == null) {
			this.lister();
		}
	}

	lister(): void {
		this.loadingIndicator = true;
		this.proprieteService.lister()
			.subscribe(
				data => {
					this.appProperties = data;
					this.loadingIndicator = false;
				},
				err => this.alertService.error(err.error, this.nomAlert)
			);
	}

	traductionFR(): any {
		return {
			"SIGALE_ANGULAR": {
				"COMPONENTS": {
					"PROPRIETE": {
						"TITRE": "Propriétés de l'application",
						"DG": {
							"PROPRIETE": "Propriété",
							"VALEUR": "Valeur"
						}
					}
				}
			}
		};
	}


	traductionIT(): any {
		return {
			"SIGALE_ANGULAR": {
				"COMPONENTS": {
					"PROPRIETE": {
						"TITRE": "Proprietà dell'applicazione",
						"DG": {
							"PROPRIETE": "Proprietà",
							"VALEUR": "Valore"
						}
					}
				}
			}
		};
	}
}
